// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/en/spring-friction/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const springFrictionEN: PageEntry = {
  id: "post.federreibung",
  locale: "en",
  slug: "spring-friction",
  seo: {
    title: "Glossary: Spring friction explained simply | Dietz GmbH",
    description: "Spring friction refers to the internal friction that occurs in a spring during its deformation. This friction can affect the performance of a spring by absorbing energy and impairi",
  },
  type: "post",
  h1: "Glossary: Spring friction explained simply",
  intro: "Spring friction refers to the internal friction that occurs in a spring during its deformation. This friction can affect the performance of a spring by absorbing energy and impairing movement. A thorough understanding of spring friction is critical to minimising unwanted energy losses and maximising the efficiency of spring systems. Engineers take spring friction into account when selecting materials, lubricants and design parameters to ensure optimum performance and service life. Controlling spring friction plays an important role in applications where precision and repeatability are required.",
  blocks: [

  ],
};
